class SideTabs {  
	constructor(el) {
		this.el = el;
		this.tabs = this.el.querySelectorAll('.block-side-tabs__tab');
		this.tabContentContainer = this.el.querySelectorAll('.block-side-tabs__tab-content-container');
		this.cardScrolls = this.el.querySelectorAll('.block-side-tabs__cards');
		this.activeIndex = 0; 

		this.handleTabClick();
		this.init();
		window.addEventListener('resize', this.adjustContentPosition);
	}

	init = () => {
		// Wait for images to load and DOM to be fully laid out before calculating positions
		const runAdjustment = () => {
			requestAnimationFrame(() => {
				// Double RAF to ensure layout is complete
				requestAnimationFrame(() => {
					setTimeout(() => {
						this.adjustContentPosition();
					}, 50);
				});
			});
		};

		const images = this.el.querySelectorAll('img');
		const totalImages = images.length;

		if (totalImages === 0) {
			// No images, just wait for layout
			runAdjustment();
		} else {
			// Wait for all images to load
			let imagesLoaded = 0;
			const checkComplete = () => {
				imagesLoaded++;
				if (imagesLoaded === totalImages) {
					runAdjustment();
				}
			};

			images.forEach((img) => {
				if (img.complete) {
					checkComplete();
				} else {
					img.addEventListener('load', checkComplete, { once: true });
					img.addEventListener('error', checkComplete, { once: true });
				}
			});
		}

		// Fallback: also call on window load to ensure everything is ready
		if (document.readyState === 'complete') {
			setTimeout(() => {
				this.adjustContentPosition();
			}, 150);
		} else {
			window.addEventListener('load', () => {
				setTimeout(() => {
					this.adjustContentPosition();
				}, 150);
			}, { once: true });
		}
	}

	handleTabClick = () => {
		this.tabs.forEach((tab) => {
			tab.addEventListener('click', () => {
				const targetIndex = parseInt(tab.dataset.index, 10);
				const currentActive = this.el.querySelector('.block-side-tabs__tab-content-container.active');
				const nextTab = this.el.querySelector(`.block-side-tabs__tab-content-container[data-index="${targetIndex}"]`);

				if (this.activeIndex === targetIndex) return;


				if (currentActive) {
					const exitClass = targetIndex > this.activeIndex ? 'exit-left' : 'exit-right';
					currentActive.classList.remove('active');
					currentActive.classList.add(exitClass);

					setTimeout(() => {
						currentActive.classList.remove(exitClass);
					}, 500);
				}

				nextTab.classList.add('active');

				this.tabs.forEach((t) => {
					t.classList.toggle('active', parseInt(t.dataset.index, 10) === targetIndex);
				});

				this.activeIndex = targetIndex;
				this.adjustContentPosition();
			});
		});
	}

	adjustContentPosition = () => {
		this.tabContentContainer.forEach((tabContent) => {
			const wrappers = tabContent.querySelectorAll(
				'.block-side-tabs__tab-content-content-wrapper'
			);
	
			wrappers.forEach((wrapper) => {
				this.setAlignment(wrapper);
			});
		});
	
		const cardScrolls = this.el.querySelectorAll('.block-side-tabs__card-content-scroll');
		cardScrolls.forEach((scroll) => {
			this.setAlignment(scroll);
		});
	}
	
	setAlignment = (wrapper) => {
		if (!wrapper) return;
		if (wrapper.scrollHeight <= wrapper.clientHeight) {
			wrapper.style.justifyContent = 'center';
		} else {
			wrapper.style.justifyContent = 'flex-start';
		}
	}
	
	
}

export default SideTabs;
